// Controls
import { ToastContent } from "../toastContent/ToastContent";
import { generateGuid } from "@ms/uno-utilities/lib/local/Guid";
import React from "react";
/**
 * Global toast dispatcher instance
 * This is set by the UnoShell during initialization
 */ let globalDispatchToast = null;
/**
 * Set the global toast dispatcher function
 * Called once during app initialization
 */ export function setGlobalToastDispatcher(dispatcher) {
    globalDispatchToast = dispatcher;
}
/**
 * Show a toast using the global dispatcher
 * @param toast The toast to display
 * @param useInvertedAppearance Whether to use inverted (dark) appearance for the toast
 * @param position Optional position for the toast (default: "bottom-start")
 */ export function showToast(toast, useInvertedAppearance = true, position = "bottom-start") {
    if (!globalDispatchToast) {
        throw new Error("Global toast dispatcher is not set");
    }
    // Generate a unique ID for the toast
    const toastId = generateGuid();
    const dispatchOptions = {
        toastId: toastId,
        intent: toast.intent === "progress" ? undefined : toast.intent,
        timeout: toast.timeout || 5000,
        position
    };
    // Dispatch the toast content with options
    globalDispatchToast(/*#__PURE__*/ React.createElement(ToastContent, {
        toast: toast,
        useInvertedAppearance: useInvertedAppearance
    }), dispatchOptions);
}
